import {RESIZE_SIDES} from '../../../editorUtils/constants';

export const tagsMetadata = {
  allowConnectToDB: true,
  resizableSides: [RESIZE_SIDES.LEFT, RESIZE_SIDES.RIGHT]
};
